export default ($) => {
    var _search = $('#news-search-field')[0];
    var loadMoreNews = $('.js-loadmore-news');
    var parent = loadMoreNews.parent();
    var postExclude = parent.data('exclude');
    var dispCats = parent.data('categories');
    var _foundResult = 0;
    var _foundCount  = 1;
    var toggle = $('.js-toggle-news');
    var stories = $('.js-story');
    var activeClasses = [];
    // var jsPress = $('.js-press');
    // var jsNews = $('.js-news');
    // var jsInTheNews = $('.js-in-the-news');
    // var jsFeatured = $('.js-featured');

    function checkActiveStories() {
        stories.each(function (index, item) {
            let classValue = $(item).attr('class').split(' ').splice(3, 1)[0];
            if (!activeClasses.includes(classValue)) {
                activeClasses.push(classValue);
            }
        });

        toggle.each(function (index, item) {
            let toggleClass = $(item).data('toggle');

            $(item).toggleClass('disabled', !activeClasses.includes(toggleClass));
			if (!activeClasses.includes(toggleClass)) {
				$(item).attr('aria-disabled', 'true');
			}
        });
    }

    if (_search) {
        searchFilter();
        toggleNews();
        checkActiveStories();
    }

    loadMoreNews.click(function() {
        var scrollPosition = $(window).scrollTop();

        var button = $(this),
            data = {
                'action': 'loadmore_news',
                'query': wp_params.posts,
                'page' : wp_params.current_page,
                'exclude' : postExclude,
                'disp_cat' : dispCats
            };

        $.ajax({
            url : wp_params.ajaxurl,
            data : data,
            type : 'POST',
            beforeSend : function () {
                button.text('Loading...');
                button.attr('disabled', true);
            },
            success : function(data) {
                if (data) {
                    button.text( 'Load More' ).attr('disabled', false);
                    parent.before(data);
                    wp_params.current_page++;
                    $(window).scrollTop(scrollPosition);

                    if (wp_params.current_page == window.maxNewsPages)
                        parent.remove();

                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    // $( document.body ).trigger( 'post-load' );
                } else {
                    parent.remove();
                }
                stories = $('.js-story');
                toggleNewsSearch();
            }
        });
    });

    function searchFilter() {
        _search.addEventListener('keyup', function () {
            var filterRegex = new RegExp('\\b' + this.value, 'gi');
            _foundResult = 0;
            _foundCount = 1;

            document.querySelectorAll('.js-story:not(.hidden-toggle)').forEach(function (item) {
                var found = item.innerText.match(filterRegex);

                if (found) {
                    _foundResult++;
                    _foundCount++;
                }

                item.classList.toggle('hidden', !found);
            });
        });
    }

    function toggleNews() {
        toggle.on('click', function () {
            $(this).toggleClass('active');

            toggleNewsSearch();
        });
    }

    function toggleNewsSearch() {
        _search.value = '';
        stories.removeClass('hidden');

        var _filter = [];

        $.each(toggle, function (_i, _item) {
            if ($(_item).hasClass('active')) {
                _filter.push($(_item).data('toggle'));
            }
        });

        if (!_filter.length) {
            stories.removeClass('hidden-toggle');
        } else {
            $.each(stories, function (i, item) {
                var check = false;

                _filter.forEach(function (_it) {
                    if (item.classList.contains(_it)) {
                        check = true;
                    }
                });

                $(item).toggleClass('hidden-toggle', !check);
            });
        }
        checkActiveStories();
    }
}